<template>
  <div class="application">
    <div class="applicationDiv">
      <div class="modules">
        <div class="lmtit">储能-应用模式</div>
        <div class="lmxian"></div>
        <el-row :gutter="20">
          <el-col :span="20" v-for="(item, index) in applications" :key="index"  :xs="24" :sm="12" :lg="6">
            <el-card  :body-style="{ padding: '0px' }">
              <el-image :src="item.image" class="image" lazy/>
              <div style="padding: 14px">
                <span>{{item.title}}</span>
                <div class="bottom clearfix">
                  <time class="time">{{item.describe}}</time>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="values">
        <div class="lmtit">储能-应用价值</div>
        <div class="lmxian"></div>
        <el-row :gutter="20" >
          <el-col :xs="24" :sm="12" :lg="6" v-for="(item,index) in values" :key="index" :span="6" >
            <el-card class="box-card" >
              <h4 style="margin: 10px 0">{{item.title}}</h4>
              <div class="text item">
                {{item.describe}}
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Application",
  data(){
    return{
      applications:[
        {title:'削峰填谷',describe:'通过谷时充电储能、峰时放电供能，减少企业或园区的用电成本，为客户节约用电端的电费',image:require('../../assets/images/production/M1.png')},
        {title:'需量响应',describe:'当短期用电功率大于变压容量时，储能系统进行快速放电，满足负载电能需求',image:require('../../assets/images/production/M2.png')},
        {title:'电力交易',describe:'在电力市场交易平台上，结合符合预测进行短期电力交易，实现收益最大化',image:require('../../assets/images/production/M3.png')},
        {title:'后备电源',describe:'在电力突然中断时，为重要负载进行紧急短时供电，降低重要负载由于断电造成的经济损失',image:require('../../assets/images/production/M4.png')}
      ],
      values:[
        {title:'减少用电成本',describe:'利用峰谷电价价差，企业可通过谷电峰用，节约用电成本'},
        {title:'实现系统备电',describe:'在电网掉电时，储能系统基于支撑，实现负荷正常运转，降低经济损失'},
        {title:'降低用户侧增容费用',describe:'利用储能设备替代峰值时变压器的容量，使得用户降低变压器使用的成本，降低变压器投资扩容的周期'},
        {title:'提升系统可靠性',describe:'稳定系统输出，改善能源的可调度性，同时改善电能质量'},
      ],
    }
  }
}
</script>

<style lang="less" scoped>
.application{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 50px 0 0 0 ;
  .lmtit{
    font-size: 30px;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
  }
  .lmxian{
    height: 1px;
    width: 60px;
    background: #287ab6;
    margin: 0 auto;
  }
  .applicationDiv{
    width:80%;
    .modules{
      justify-content: center;
      .el-card{
        margin: 20px 0;
        .time {
          font-size: 13px;
          color: #999;
        }
        .bottom {
          margin-top: 13px;
          line-height: 12px;
        }
        .button {
          padding: 0;
          float: right;
        }
        .image {
          max-height: 240px;
          display: block;
          aspect-ratio: 16/9;
        }
        .clearfix:before,
        .clearfix:after {
          display: table;
          content: "";
        }
        .clearfix:after {
          clear: both
        }
      }
    }
    .values{
      .el-card{
        margin:20px 0;
        max-height:180px;
        height:180px;
        .text {
          font-size: 14px;
        }
        .item {
          padding: 8px 0;
        }
        .box-card {
          width:480px
        }
      }
    }
  }
}





</style>
